// @ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

export const open = (modalInstanceName, params = {}) =>
  LKModalActions.open({
    name: modalInstanceName,
    modalType: 'add',
    ...params,
  })
